/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { useEffect } from "react";
import PageNotFound from "../../../components/404page/PageNotFound";
import { resetPassword } from "../../../actions/auth";
import { useLoading } from "../../../components/LoadingContext";
import { EyeIcon, EyeOffIcon } from "../../../components/icons";

const floatingInputClass = (valid) =>
  `tw:peer tw:block! tw:w-full tw:h-[calc(3.5rem+2px)] tw:leading-[1.25] tw:bg-white tw:border tw:rounded-[0.3rem] tw:pt-[1.625rem] tw:pb-[0.625rem] tw:pr-3 tw:pl-[1.1rem] tw:placeholder-transparent tw:[font-family:var(--font-sans-primary)] tw:focus:outline-none tw:focus:shadow-[0_0_0_0.25rem_rgba(13,110,253,0.25)] tw:disabled:bg-[rgba(167,167,167,0.1)] ${
    valid
      ? "tw:text-[14px] tw:text-[#4e4e4e] tw:border-[#f1f1f1] tw:focus:border-[#c9c9c9]"
      : "tw:text-[15px] tw:bg-[rgba(167,167,167,0.1)] tw:text-[red] tw:border-[red]"
  }`;

const floatingLabelClass =
  "tw:absolute tw:top-0 tw:left-0 tw:h-full tw:pl-4 tw:pt-4 tw:pr-3 tw:pointer-events-none tw:text-[14px] tw:text-[#a7a7a7] tw:[font-family:var(--font-sans-primary)] tw:origin-[0_0] tw:transition-[opacity,transform] tw:duration-100 tw:ease-in-out tw:scale-[0.85] tw:-translate-y-2 tw:translate-x-[0.15rem] tw:peer-placeholder-shown:scale-100 tw:peer-placeholder-shown:translate-y-0 tw:peer-placeholder-shown:translate-x-0 tw:peer-focus:scale-[0.85] tw:peer-focus:-translate-y-2 tw:peer-focus:translate-x-[0.15rem]";

const ResetPassword = ({ match }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [isValidPassword, setIsValidPassword] = useState(true);
  const [isPasswordConfirmed, setIsPasswordConfirmed] = useState(true);
  const [successResetPassword, setSuccessResetPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);
  const { showLoading, closeLoading } = useLoading();

  const [pageExpired, setPageExpired] = useState(false);

  const token = match.params.token;

  const handleEmailChange = (event) => {
    const emailValue = event.target.value;
    setEmail(emailValue);
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
    setIsValidEmail(isValid);
  };

  const handlePasswordChange = (event) => {
    const passwordValue = event.target.value;
    setPassword(passwordValue);
    // Validate password length (at least 8 characters)
    setIsValidPassword(passwordValue.length >= 8);
    // Check if password confirmation matches password
    setIsPasswordConfirmed(passwordValue === passwordConfirmation);
  };

  const handlePasswordConfirmationChange = (event) => {
    const confirmationValue = event.target.value;
    setPasswordConfirmation(confirmationValue);
    // Check if password confirmation matches password
    setIsPasswordConfirmed(password === confirmationValue);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const togglePasswordConfirmationVisibility = () => {
    setShowPasswordConfirmation(!showPasswordConfirmation);
  };

  const handleUpdatePassword = async () => {
    showLoading(true);
    
    // Validation check
    if (isValidEmail && isValidPassword && isPasswordConfirmed) {
      const resetPasswordResponse = await resetPassword(email, token, password, passwordConfirmation);
      if(resetPasswordResponse.code === 201 || resetPasswordResponse.code === 200){
        setSuccessResetPassword(true);
      }
    } else {

    }
    closeLoading(true);
  };

  useEffect(() => {
    var jwt = JSON.parse(atob(token.split(".")[1]));
    var user = jwt.user;
    if(user){
      setEmail(user.email);
    }
    if (jwt.exp * 1000 < Date.now()) {
      setPageExpired(true);
    }
  }, []);

  return pageExpired ? (
    <PageNotFound />
  ) : (
    <FrontLayout>
      <div className="custom-mx tw:mt-4 tw:pt-4 tw:sm:mt-12 tw:sm:pt-12">
        <div className="custom-mt-6 tw:w-full tw:mx-auto tw:px-3 tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:pb-12 tw:md:pb-0 tw:pt-12 tw:md:pt-0">
          <div className="tw:flex tw:flex-wrap tw:-mx-3 tw:pb-12 tw:lg:justify-center">
            <div className="tw:w-full tw:md:w-[83.3333%] tw:px-12 tw:py-12">
              <div className="tw:flex tw:flex-wrap tw:-mx-3 tw:mb-12">
              {successResetPassword ?
                    <div className="tw:w-full tw:mx-auto tw:px-3">
                      <h2>Password Successfully Reset</h2>
                      <p className="tw:mt-4">Your password has been successfully reset. Please log in using your latest password. Thank you.</p>

                    </div> : <div className="tw:w-full tw:px-3 tw:md:w-1/2 tw:md:ml-[25%]">

                   <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem]">
                    <div className="tw:flex-1 tw:p-4">
                      <h5 className="tw:mb-4">Reset Password</h5>
                      <div className="tw:relative tw:mb-4">
                        <input
                          type="email"
                          className={floatingInputClass(isValidEmail)}
                          id="emailInput"
                          placeholder="name@example.com"
                          value={email}
                          onChange={handleEmailChange}
                          required
                          disabled
                        />
                        <label htmlFor="emailInput" className={floatingLabelClass}>Email address</label>
                        {isValidEmail ? (
                          ""
                        ) : (
                          <p className="tw:text-[#dc3545]!">
                            Please enter a valid email address
                          </p>
                        )}
                      </div>
                      <div className="tw:relative tw:mb-4">
                        <input
                          type={showPassword ? "text" : "password"}
                          className={floatingInputClass(isValidPassword)}
                          id="passwordInput"
                          placeholder="New Password"
                          value={password}
                          onChange={handlePasswordChange}
                          style={{ paddingRight: '45px' }}
                          required
                        />
                        <label htmlFor="passwordInput" className={floatingLabelClass}>New Password</label>
                        <div 
                          onClick={togglePasswordVisibility}
                          style={{ 
                            position: 'absolute',
                            right: '12px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            zIndex: 5,
                            display: 'flex',
                            alignItems: 'center',
                            padding: '4px'
                          }}
                        >
                          {showPassword ? (
                            <EyeIcon />
                          ) : (
                            <EyeOffIcon />
                          )}
                        </div>
                        {isValidPassword ? (
                          ""
                        ) : (
                          <p className="tw:text-[#dc3545]!">
                            Password must be at least 8 characters long
                          </p>
                        )}
                      </div>
                      <div className="tw:relative tw:mb-4">
                        <input
                          type={showPasswordConfirmation ? "text" : "password"}
                          className={floatingInputClass(isPasswordConfirmed)}
                          id="passwordConfirmationInput"
                          placeholder="Password Confirmation"
                          value={passwordConfirmation}
                          onChange={handlePasswordConfirmationChange}
                          style={{ paddingRight: '45px' }}
                          required
                        />
                        <label htmlFor="passwordConfirmationInput" className={floatingLabelClass}>
                          Password Confirmation
                        </label>
                        <div 
                          onClick={togglePasswordConfirmationVisibility}
                          style={{ 
                            position: 'absolute',
                            right: '12px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            zIndex: 5,
                            display: 'flex',
                            alignItems: 'center',
                            padding: '4px'
                          }}
                        >
                          {showPasswordConfirmation ? (
                            <EyeIcon />
                          ) : (
                            <EyeOffIcon />
                          )}
                        </div>
                        {isPasswordConfirmed ? (
                          ""
                        ) : (
                          <p className="tw:text-[#dc3545]!">
                            Password confirmation does not match
                          </p>
                        )}
                      </div>
                      <div className="tw:grid">
                        <button
                          className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:px-3 tw:py-2 tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:bg-[#d4b055] tw:border-[#d4b055] tw:text-[#4a4a4a] tw:hover:bg-[#c2a86b] tw:hover:border-[#c2a86b] tw:hover:opacity-60 tw:disabled:opacity-65 tw:disabled:pointer-events-none"
                          onClick={handleUpdatePassword}
                          disabled={
                            !isValidEmail ||
                            !isValidPassword ||
                            !isPasswordConfirmed
                          }
                        >
                          Update Password
                        </button>
                      </div>
                    </div>
                  </div> 
                </div> }
              </div>
            </div>
          </div>
        </div>
      </div>
    </FrontLayout>
  );
};

export default ResetPassword;
